{
  "open": "Open chat",
  "unread_one": "{count} unread message",
  "unread_other": "{count} unread messages",
  "close": "Close"
}
